"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const ArrayFieldSelect = props => {
  const schema = props.schema,
        idSchema = props.idSchema,
        uiSchema = props.uiSchema,
        formData = props.formData,
        disabled = props.disabled,
        readonly = props.readonly,
        required = props.required,
        label = props.label,
        placeholder = props.placeholder,
        autofocus = props.autofocus,
        onBlur = props.onBlur,
        onFocus = props.onFocus,
        registry = props.registry,
        rawErrors = props.rawErrors,
        onChange = props.onChange;
  const items = (0, _utils.getDefaultFormState)(schema, props.formData);
  const widgets = registry.widgets,
        definitions = registry.definitions,
        formContext = registry.formContext;
  const itemsSchema = (0, _utils.retrieveSchema)(schema.items, definitions, formData);
  const enumOptions = (0, _utils.optionsList)(itemsSchema);

  const _getUiOptions$enumOpt = _extends({}, (0, _utils.getUiOptions)(uiSchema), {
    enumOptions
  }),
        _getUiOptions$enumOpt2 = _getUiOptions$enumOpt.widget,
        widget = _getUiOptions$enumOpt2 === void 0 ? "select" : _getUiOptions$enumOpt2,
        options = _objectWithoutPropertiesLoose(_getUiOptions$enumOpt, ["widget"]);

  const Widget = (0, _utils.getWidget)(schema, widget, widgets);
  const SchemaLayout = registry.fields.SchemaLayout;
  return _react.default.createElement(SchemaLayout, _extends({}, props, {
    uiSchema: _extends({}, uiSchema, {
      "ui:layout": "field"
    })
  }), _react.default.createElement(Widget, {
    id: idSchema && idSchema.$id,
    multiple: true,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    options: options,
    schema: schema,
    registry: registry,
    value: items,
    disabled: disabled,
    readonly: readonly,
    required: required,
    label: label,
    placeholder: placeholder,
    formContext: formContext,
    autofocus: autofocus,
    rawErrors: rawErrors
  }));
};
/*

class ArrayFieldSelect extends Component {

    onSelectChange = (value) => {
        this.props.onChange(value);
    }

    render() {

        const {
            schema,
            idSchema,
            uiSchema,
            formData,
            disabled,
            readonly,
            autofocus,
            onBlur,
            onFocus,
            registry,
            rawErrors,
        } = this.props;

        const items = this.props.formData;
        const { widgets, definitions, formContext } = registry;
        const itemsSchema = retrieveSchema(schema.items, definitions, formData);
        const enumOptions = optionsList(itemsSchema);
        const { widget = "select", ...options } = {
            ...getUiOptions(uiSchema),
            enumOptions,
        };
        const Widget = getWidget(schema, widget, widgets);
        
        const uiOptions = {
            ...this.props.uiOptions,
            addable: false
        }

        const { SchemaLayout } = registry.fields

        return (
            <SchemaLayout {...this.props} uiSchema={{...uiSchema, "ui:layout": "field"}} uiOptions={uiOptions}>
                <Widget
                    id={idSchema && idSchema.$id}
                    multiple={true}
                    onChange={this.onSelectChange}
                    onBlur={onBlur}
                    onFocus={onFocus}
                    options={{ ...options, enumOptions }}
                    schema={schema}
                    value={items || []}
                    disabled={disabled}
                    readonly={readonly}
                    formContext={formContext}
                    autofocus={autofocus}
                    rawErrors={rawErrors}
                />
            </SchemaLayout>
        );


    }
}

*/


var _default = ArrayFieldSelect;
exports.default = _default;
module.exports = exports.default;